import type { FC } from 'react';

import { SITE_CONTAINER } from '@/features/home/constants/homeStyles.constants';
import type { ProblemCard } from '@/types/home.types';

interface ProblemSectionProps {
  headline: string;
  cards: ProblemCard[];
}

const ProblemSection: FC<ProblemSectionProps> = ({ headline, cards }) => (
  <section className="bg-site-bg">
    <div className={SITE_CONTAINER}>
      <hr className="h-0.5 border-0 bg-site-line" />

      <div className="py-14 md:py-[72px]">
        <h2 className="max-w-[20ch] font-site text-[clamp(30px,3.6vw,48px)] leading-[1.08] font-extrabold tracking-[-0.02em]">
          {headline}
        </h2>

        <div className="mt-10 grid grid-cols-[repeat(auto-fit,minmax(min(100%,240px),1fr))] border-t-2 border-site-ink md:mt-12">
          {cards.map((card, index) => (
            <div
              key={card.title}
              className={`py-6 pb-2 ${
                index === 0
                  ? 'pr-0 sm:border-r-2 sm:border-site-line sm:pr-6'
                  : 'border-t-2 border-site-line pl-0 sm:border-t-0 sm:pl-6'
              }`}
            >
              <div className="font-site text-[20px] font-extrabold">{card.title}</div>
              <p className="mt-2 font-site text-base leading-[1.5] text-site-ink/80">{card.body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default ProblemSection;
